import {
  signInWithEmailAndPassword,
  signInWithPopup,
  GoogleAuthProvider,
  signOut as firebaseSignOut,
  createUserWithEmailAndPassword,
  sendPasswordResetEmail as firebaseSendPasswordResetEmail,
  setPersistence,
  browserLocalPersistence,
  getIdToken,
  onAuthStateChanged,
} from 'firebase/auth';
import { auth } from 'utils/firebase';

export const signIn = async (email, password) => {
  await setPersistence(auth, browserLocalPersistence);
  const result = await signInWithEmailAndPassword(auth, email, password);
  return result;
};

export const signInWithGoogle = async () => {
  const googleProvider = new GoogleAuthProvider();
  await signInWithPopup(auth, googleProvider);
};

export const signOut = async () => {
  await firebaseSignOut(auth);
};

export const createNewUser = async (email, password) => {
  const user = await createUserWithEmailAndPassword(auth, email, password);
  return user;
};

export const sendPasswordResetEmail = async (email) => {
  await firebaseSendPasswordResetEmail(auth, email);
};

export const getFirebaseToken = async () => {
  if (auth.currentUser) {
    await getIdToken(auth.currentUser);
  }
};

export const currentUser = () => auth.currentUser;

export const onAuthStateChange = (callback) => onAuthStateChanged(auth, callback);
